import { compose } from '@reduxjs/toolkit';
import { loadAddressesReducer } from './loadAddresses';

export const extraReducers = compose(loadAddressesReducer);
export { loadAddressesAction } from './loadAddresses';
